export enum ErrorType{
    UnProcessable
}

export class CustomError extends Error{

    errorType: ErrorType;
    Count: number;
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/model/ErrorType.ts